import { render, staticRenderFns } from "./ViewTable.vue?vue&type=template&id=36bbfbd3&scoped=true"
import script from "./ViewTable.vue?vue&type=script&lang=js"
export * from "./ViewTable.vue?vue&type=script&lang=js"
import style0 from "./ViewTable.vue?vue&type=style&index=0&id=36bbfbd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbfbd3",
  null
  
)

export default component.exports